import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import { Rnd } from 'react-rnd';
import FontAwesome from 'react-fontawesome';

import { roundNumber, copy, isEmpty } from './functions.js';
// import "ie-array-find-polyfill";

class ResizeSymbolPreviewLayer extends React.Component {

    symbolPath = 'https://www.hundeshop.de/out/pictures/productdesigner/symboles/';
    layerSymbolMinHeight = 0;
    layerSymbolMinWidth = 0;

    constructor(props) {
        super(props);


        const loaderStyle = {
            width: this.props.contentLayer.dimensions.width + 'px',
            height: this.props.contentLayer.dimensions.height + 'px',
            lineHeight: this.props.contentLayer.dimensions.height + 'px'
        };

        this.state = {
            height: this.props.contentLayer.dimensions.height,
            width: this.props.contentLayer.dimensions.width,
            contentLayer: copy(this.props.contentLayer),
            symbolInitDone: false,
            symbolCanRoate: -1,
            symbolNeedsRotation: -1,
            checkMinWidth: -1,
            activeDesignerVariants: this.props.activeDesignerVariants,
            symbolSvg: (<div className='layer_content_symbol' >
                <div className="symbol_loader_icon" style={loaderStyle}>
                    <FontAwesome
                        name='circle-o-notch'
                        size='2x'
                        spin
                    />
                </div>
            </div>)
        }

        this.setLayerSymbolMinSize(this.props.contentLayer);


        this.handleSymbolRotateEnd = this.handleSymbolRotateEnd.bind(this);
        this.handleSymbolRotateStart = this.handleSymbolRotateStart.bind(this);
        this.handleSymbolRotate = this.handleSymbolRotate.bind(this);
        this.handleSymbolRemove = this.handleSymbolRemove.bind(this);
        this.handleSymbolFlip = this.handleSymbolFlip.bind(this);
        this.handleLayerSelect = this.handleLayerSelect.bind(this);
        this.handleLayerMove = this.handleLayerMove.bind(this);
        this.handleLayerMoveEnd = this.handleLayerMoveEnd.bind(this);
        this.handleLayerResize = this.handleLayerResize.bind(this);
        this.handleLayerResizeEnd = this.handleLayerResizeEnd.bind(this);

        this.symbolRotateSvgTransform = null;
        this.symbolSvgViewbox = null;
        this.symbolSvgGElement = null;
        this.symbolRotateCenterX = 0;
        this.symbolRotateCenterY = 0;
        this.symbolRotateViewboxX = 0;
        this.symbolRotateViewboxY = 0;
        this.symbolRotateViewboxOrgX = 0;
        this.symbolRotateViewboxOrgY = 0;

        this.initSvgSymbol();
    }

    handleSymbolRotateStart(e, data) {
        if (this.state.symbolCanRoate === 1)
        {
            if (this.state.symbolNeedsRotation === 1)
                this.initSymbolRotation();

            this.setState({
                symbolNeedsRotation: -1
            });

            this.symbolRotateCenterX = data.x - (this.state.width / 2);
            this.symbolRotateCenterY = data.y + (this.state.height / 2);
        }
    }

    initSymbolRotation(){

        const svgElements = this.getSvgElements();
        if (svgElements !== undefined && svgElements !== null & svgElements.length >= 1)
        {
            const svgEl = svgElements[0];
            const gElements = svgEl.getElementsByTagName('g');

            if (gElements !== undefined && gElements !== null & gElements.length >= 1)
            {
                this.symbolSvgGElement = gElements[0];

                if (isEmpty(this.symbolRotateSvgTransform))
                {
                    let symbolRotateSvgTransform = this.symbolSvgGElement.getAttribute('transform');

                    if (symbolRotateSvgTransform.indexOf('rotate') != -1)
                        symbolRotateSvgTransform = symbolRotateSvgTransform.substr(0, symbolRotateSvgTransform.indexOf('rotate'));

                    this.symbolRotateSvgTransform = symbolRotateSvgTransform;
                    this.symbolSvgGElement.setAttribute('transform', this.symbolRotateSvgTransform + " rotate(0 5000 5000)");
                }

                if (isEmpty(this.symbolSvgViewbox))
                {
                    this.symbolSvgViewbox = svgEl.getAttribute('viewBox');;
                }

                const svgViewboxArr = this.symbolSvgViewbox.split(" ");
                this.symbolRotateViewboxOrgX = parseInt(svgViewboxArr[2]);
                this.symbolRotateViewboxOrgY = parseInt(svgViewboxArr[3]);
                this.symbolRotateViewboxX = this.symbolRotateViewboxOrgX * 10 / 2;
                this.symbolRotateViewboxY = this.symbolRotateViewboxOrgY * 10 / 2;

                let subVb = this.symbolRotateViewboxOrgX - this.symbolRotateViewboxOrgY;

                if (this.symbolRotateViewboxOrgX < this.symbolRotateViewboxOrgY)
                    subVb = this.symbolRotateViewboxOrgY - this.symbolRotateViewboxOrgX;

                svgEl.setAttribute('viewBox',
                    ((this.symbolRotateViewboxOrgX+subVb)*2/10*-1) + ' ' +
                    ((this.symbolRotateViewboxOrgY+subVb)*2/10*-1) + ' ' +
                    ((this.symbolRotateViewboxOrgX+subVb)*1.25) + ' ' +
                    ((this.symbolRotateViewboxOrgY+subVb)*1.25)
                );
            }
        }
    }

    getSvgElements(){
        let svgElement = this.symbolPreviewLayer.getElementsByTagName("svg");
        if (svgElement === undefined || svgElement === null || svgElement.length <= 0)
            this.symbolPreviewLayer.getElementsByTagName("SVG");

        return svgElement;
    }

    handleSymbolRotate(e, data) {
        if (this.state.symbolCanRoate === 1)
        {
            const radians = Math.atan2(this.symbolRotateCenterX - data.x, data.y - this.symbolRotateCenterY);
            let degree = (radians * (180 / Math.PI) * -1) + 225;

            if (this.state.contentLayer.symbolFlip)
                degree = degree * -1;

            this.symbolSvgGElement.setAttribute('transform', this.symbolRotateSvgTransform + " rotate("+degree+" "+this.symbolRotateViewboxX+" "+this.symbolRotateViewboxY+")");
        }
    }

    handleSymbolRotateEnd(e, data) {

        if (this.state.symbolCanRoate === 1)
        {
            const radians = Math.atan2(this.symbolRotateCenterX - data.x, data.y - this.symbolRotateCenterY);
            let degree = (radians * (180 / Math.PI) * -1) + 225;

            if (this.state.contentLayer.symbolFlip)
                degree = degree * -1;

            const layer = this.props.contentLayer;
            layer.symbolRotation = degree;

            this.props.onContentLayerChange(layer);


        }

        this.rotateRnd.updatePosition({
            x: this.state.contentLayer.dimensions.posX + this.state.contentLayer.dimensions.width,
            y: this.state.contentLayer.dimensions.posY - 24
        });
    }

    handleSymbolFlip(e) {
        e.preventDefault();
        const layer = this.props.contentLayer;
        layer.symbolFlip = !layer.symbolFlip;
        this.props.onContentLayerChange(layer);
    }

    handleSymbolRemove(e) {
        this.props.onContentLayerRemove(this.props.contentLayer);
    }

    handleLayerSelect(e) {
        this.props.onContentLayerSelect(this.props.layerIndex);
    }

    initSvgSymbol() {

        if (this.state.symbolInitDone)
            return;

        return fetch(this.symbolPath + this.props.contentLayer.content.file)
        .then((response) => response.text())
        .then((responseText) => {

            responseText = responseText.toString();
            if (responseText.indexOf('<svg') > -1)
            {
                responseText = responseText.substr(responseText.indexOf('<svg'));
                responseText = responseText.substr(0, responseText.indexOf('</svg>')) + '</svg>';
            }
            else if (responseText.indexOf('<SVG') > -1)
            {
                responseText = responseText.substr(responseText.indexOf('<SVG'));
                responseText = responseText.substr(0, responseText.indexOf('</SVG>')) + '</SVG>';
            }

            this.setState({
                symbolSvg: <div dangerouslySetInnerHTML={{__html:responseText}} className='layer_content_symbol' />,
                symbolNeedsRotation: 1,
                symbolInitDone: true,
            })
        })
        .catch((error) => {

            console.error(error);
        });

    }

    handleLayerResize(e, dir, ref, delta, pos) {

        const layer = this.state.contentLayer;
        layer.dimensions.height = ref.offsetHeight;
        layer.dimensions.width = ref.offsetWidth;

        this.setState({
            contentLayer: layer,
            height: layer.dimensions.height,
            width: layer.dimensions.width
        })
    }

    handleLayerResizeEnd(e, dir, ref, delta, pos) {

        const layer = this.state.contentLayer;
        layer.dimensions.height = ref.offsetHeight;
        layer.dimensions.width = ref.offsetWidth;

        this.props.onContentLayerChange(layer);
    }

    handleLayerMove(e, data) {

        const layer = this.state.contentLayer;

        if (data.y >= 0 && data.y <= layer.maxDimensions.height - layer.dimensions.height)
            layer.dimensions.posY = data.y;

        if (data.x >= 0 && data.x <= layer.maxDimensions.width - layer.dimensions.width)
            layer.dimensions.posX = data.x;

        if ((data.y >= 0 && data.y <= layer.maxDimensions.height - layer.dimensions.height)||
            (data.x >= 0 && data.x <= layer.maxDimensions.width - layer.dimensions.width))
        {
            this.setState({
                contentLayer: layer
            })
        }
        else if (this.rnd !== null && this.rnd !== undefined)
        {
            this.rnd.updatePosition({ x: this.props.contentLayer.dimensions.posX, y: this.props.contentLayer.dimensions.posY });
            this.rnd.updateSize({ width: this.props.contentLayer.dimensions.width, height: this.props.contentLayer.dimensions.height });
        }
    }

    handleLayerMoveEnd(e, data) {

        const layer = this.state.contentLayer;

        if ((data.y < 0 || data.y > layer.maxDimensions.height - layer.dimensions.height) ||
            (data.x < 0 && data.x > layer.maxDimensions.width - layer.dimensions.width))
        {
            if (this.rnd !== null && this.rnd !== undefined)
            {
                this.rnd.updatePosition({ x: this.props.contentLayer.dimensions.posX, y: this.props.contentLayer.dimensions.posY });
                this.rnd.updateSize({ width: this.props.contentLayer.dimensions.width, height: this.props.contentLayer.dimensions.height });
            }

            this.setState({
                contentLayer: this.props.contentLayer
            })
        }
        else
        {
            layer.dimensions.posY = data.y;
            layer.dimensions.posX = data.x;

            this.props.onContentLayerChange(layer);
        }
    }

    componentDidMount() {

    }

    componentDidUpdate() {

        const svgElements = this.getSvgElements();

        if (svgElements !== undefined && svgElements !== null & svgElements.length >= 1)
        {
            // set svg size
            if (svgElements[0].style != this.state.width || svgElements[0].style.height != this.state.height + 'px')
            {
                svgElements[0].style.width = this.state.width + 'px';
                svgElements[0].style.height = this.state.height + 'px';
            }

            // handle min size
            const newLayer = copy(this.props.contentLayer);
            if (this.layerSymbolMinWidth > newLayer.dimensions.width || this.layerSymbolMinHeight > newLayer.dimensions.height)
            {
                if (this.layerSymbolMinWidth > newLayer.dimensions.width)
                {
                    if (newLayer.dimensions.posX + this.layerSymbolMinWidth > newLayer.maxDimensions.posX + newLayer.maxDimensions.width)
                    {
                        newLayer.dimensions.posX = newLayer.dimensions.posX - (this.layerSymbolMinWidth - newLayer.dimensions.width);
                    }
                    newLayer.dimensions.width = this.layerSymbolMinWidth;
                    svgElements[0].style.width = this.layerSymbolMinWidth + 'px';
                }

                if (this.layerSymbolMinHeight > newLayer.dimensions.height)
                {
                    if (newLayer.dimensions.posY + this.layerSymbolMinHeight > newLayer.maxDimensions.posY + newLayer.maxDimensions.height)
                    {
                        newLayer.dimensions.posY = newLayer.dimensions.posY - (this.layerSymbolMinHeight - newLayer.dimensions.height);
                    }

                    newLayer.dimensions.height = this.layerSymbolMinHeight;
                    svgElements[0].style.height = this.layerSymbolMinHeight + 'px';
                }


                if (this.rnd !== null && this.rnd !== undefined)
                {
                    this.rnd.updatePosition({ x: newLayer.dimensions.posX, y: newLayer.dimensions.posY });
                    this.rnd.updateSize({ width: newLayer.dimensions.width, height: newLayer.dimensions.height });
                }

                this.props.onContentLayerChange(newLayer);

                if (this.state.width != newLayer.dimensions.width || this.state.height != newLayer.dimensions.height)
                {
                    this.setState({
                        width: newLayer.dimensions.width,
                        height: newLayer.dimensions.height,
                        contentLayer: newLayer,
                    });
                }
            }

            // set svg color
            let pathElements = this.symbolPreviewLayer.getElementsByTagName("path");
            if (pathElements === undefined || pathElements === null || pathElements.length <= 0)
                pathElements = this.symbolPreviewLayer.getElementsByTagName("PATH");

            let colorHex = this.props.activeColor.color_hex;
            if (this.props.contentLayer.color !== undefined && this.props.contentLayer.color != 'inherit')
            {
                colorHex = this.props.contentLayer.color.color_hex;
            }

            for (var pi = 0; pi < pathElements.length; pi++) {
                if (pathElements[pi].style.fill != colorHex)
                    pathElements[pi].style.fill = colorHex;
            }

            // check if svg supports rotation
            if (this.state.symbolCanRoate === -1)
            {
                let gElements = svgElements[0].getElementsByTagName('g');
                let canRotate = 0;
                for (var gI = 0; gI < gElements.length; gI++) {

                    const svgTransform = gElements[gI].getAttribute('transform');
                    if (svgTransform != undefined && svgTransform != null)
                    {
                        canRotate = 1;
                        break;
                    }
                }

                this.setState({
                    symbolCanRoate: canRotate
                });
            }

            // rotate symbol
            if (this.state.symbolNeedsRotation === 1 && !isEmpty(this.state.contentLayer.symbolRotation))
            {
                this.initSymbolRotation();
                this.symbolSvgGElement.setAttribute('transform', this.symbolRotateSvgTransform + " rotate("+this.state.contentLayer.symbolRotation+" "+this.symbolRotateViewboxX+" "+this.symbolRotateViewboxY+")");
                this.setState({
                    symbolNeedsRotation: -1,
                });
            }
        }

        if (this.state.activeDesignerVariants != this.props.activeDesignerVariants)
        {
            this.setState({
                activeDesignerVariants: this.props.activeDesignerVariants,
                checkMinWidth: 1
            });
        }
        if (this.state.checkMinWidth === 1)
        {
            this.setLayerSymbolMinSize(this.props.contentLayer);
            this.setState({
                checkMinWidth: -1,
            });
        }

        // update rotate handle position
        if (this.rotateRnd !== undefined && this.rotateRnd !== null && this.rotateRnd.draggable !== undefined)
        {
            this.rotateRnd.updatePosition({
                x: this.state.contentLayer.dimensions.posX + this.state.contentLayer.dimensions.width,
                y: this.state.contentLayer.dimensions.posY - 24
            });
            // this.rotateRnd.updateZIndex(this.getLayerZIndex());
        }
        if (this.rnd !== null && this.rnd !== undefined)
        {
            // this.rnd.updateZIndex(this.getLayerZIndex());
        }
    }

    getExportHeightInMm(contentLayer) {

        let exportHeightInMm = contentLayer.exportHeightMm;
        const exportSizeVar = this.props.activeDesignerVariants.find(desvar => {
            return desvar.isExportSize == "1";
        });

        if (exportSizeVar !== null && exportSizeVar !== undefined && exportSizeVar.selectedVar !== null && exportSizeVar.selectedVar.export_sizes.length > 0)
        {
            const exportSize = exportSizeVar.selectedVar.export_sizes.find(es => {
                return es.perspective_id == this.props.activePerspective.id;
            });

            if (exportSize !== null && exportSize !== undefined)
            {
                const varExportWidthInMm = parseFloat(exportSize.export_width_mm);
                if (varExportWidthInMm > 0)
                {
                    exportHeightInMm = parseFloat(varExportWidthInMm * this.state.contentLayer.maxDimensions.height / this.state.contentLayer.maxDimensions.width);
                }
            }
        }

        return exportHeightInMm;
    }

    getExportWidthInMm(contentLayer) {

        let exportWidthInMm = contentLayer.exportWidthMm;
        const exportSizeVar = this.props.activeDesignerVariants.find(desvar => {
            return desvar.isExportSize == "1";
        });

        if (exportSizeVar !== null && exportSizeVar !== undefined && exportSizeVar.selectedVar !== null && exportSizeVar.selectedVar.export_sizes.length > 0)
        {
            const exportSize = exportSizeVar.selectedVar.export_sizes.find(es => {
                return es.perspective_id == this.props.activePerspective.id;
            });

            if (exportSize !== null && exportSize !== undefined)
            {
                return parseFloat(exportSize.export_width_mm);
            }
        }

        return exportWidthInMm;
    }

    setLayerSymbolMinSize(contentLayer) {

        const exportHeightInMm = this.getExportHeightInMm(contentLayer);
        const exportWidthInMm = this.getExportWidthInMm(contentLayer);

        let exportSizeInMm = exportHeightInMm;
        let exportSizeInPx = contentLayer.maxDimensions.height;

        if (exportWidthInMm < exportSizeInMm)
        {
            exportSizeInMm = exportWidthInMm;
            exportSizeInPx = contentLayer.maxDimensions.width;
        }

        let minSymSizeInMm = 15;
        if (minSymSizeInMm < exportSizeInMm / 5)
            minSymSizeInMm = exportSizeInMm / 5

        if (minSymSizeInMm > 40)
            minSymSizeInMm = 40;


        let minSizePx = exportSizeInPx * minSymSizeInMm / exportSizeInMm;
        if (isNaN(minSizePx) || !isFinite(minSizePx))
            minSizePx = 30;

        this.layerSymbolMinWidth = minSizePx;
        this.layerSymbolMinHeight = minSizePx;
    }

    isLayerVisible() {
        if (this.props.activePerspective.id != this.state.contentLayer.perspectiveId ||
            this.props.activePerspective.varid != this.state.contentLayer.perspective_varid ||
            this.state.contentLayer.content === '' ||
            this.state.contentLayer.content === null)
            return false;

        return true;
    }

    getLayerZIndex() {
        return (100 - (this.props.layerIndex * 2));
    }


    render() {

        const layerPositionStyle = {
            top: this.state.contentLayer.dimensions.posY.toString() + 'px',
            left: this.state.contentLayer.dimensions.posX.toString()  + 'px',
            zIndex: this.getLayerZIndex()
        };

        const layerActiveStyle = {
            width: this.state.contentLayer.dimensions.width,
            height: this.state.contentLayer.dimensions.height,
            top: '0px',
            left: '0px'
        };

        const layerMaxBounds = {
            top: this.state.contentLayer.maxDimensions.posY.toString() + 'px',
            left: this.state.contentLayer.maxDimensions.posX.toString() + 'px',
            width: this.state.contentLayer.maxDimensions.width.toString() + 'px',
            height: this.state.contentLayer.maxDimensions.height.toString() + 'px',
        }


        if (!this.isLayerVisible())
            layerMaxBounds.display = 'none';


        let layerMoveStyle = {
            width: this.state.contentLayer.dimensions.width,
            height: this.state.contentLayer.dimensions.height,
            top: this.state.contentLayer.dimensions.posX,
            left: this.state.contentLayer.dimensions.posY,
            zIndex: this.getLayerZIndex()
        }



        return (
            <div className={"preview_layer layer_max_bounds " + (this.props.contentLayer.symbolFlip ? ' symbol_flip' : '')} style={layerMaxBounds}>
                <div className="layer_position_wrapper" style={layerPositionStyle}>
                    <div className="layer_resize_wrapper" ref={ (layerResizeWrapper) => this.layerResizeWrapper = layerResizeWrapper}>
                        <div className="layer_rotate_wrapper">
                            <div className='symbol_svg_layer' ref={ (s) => this.symbolPreviewLayer = s}>
                                {this.state.symbolSvg}
                            </div>
                        </div>
                    </div>
                </div>

                {
                    // Render if props.designerRenderMode is 'designer'
                    this.props.designerRenderMode == 'designer' ?
                    <Rnd
                        style={{ background: 'transparent', zIndex: layerMoveStyle.zIndex }}
                        default={{
                            x: layerMoveStyle.top,
                            y: layerMoveStyle.left,
                            width: layerMoveStyle.width,
                            height: layerMoveStyle.height
                        }}
                        ref={c => { this.rnd = c; }}
                        minHeight={this.layerSymbolMinHeight}
                        minWidth={this.layerSymbolMinWidth}
                        className={"layer_rnd_wrapper" + (this.props.isActiveLayer ? ' active' : '')}
                        resizeHandleClasses={{ bottomRight: 'layer_handle layer_resize_handle fa fa-expand fa-flip-horizontal'}}
                        onDrag={this.handleLayerMove}
                        onDragStop={this.handleLayerMoveEnd}
                        onResize={this.handleLayerResize}
                        onResizeStop={this.handleLayerResizeEnd}
                        bounds={'parent'}
                        dragHandleClassName='layer_active_wrapper'
                        scale={this.props.responsiveScale}
                        enableResizing={{ top:false, right:false, bottom:false, left:false, topRight:false, bottomRight:true, bottomLeft:false, topLeft:false }}
                    >
                        <div className={"layer_active_wrapper" + (this.props.isActiveLayer ? ' active' : '')} style={layerActiveStyle} onMouseDown={this.handleLayerSelect} > </div>
                        <div className="layer_handle layer_flip_handle" onClick={this.handleSymbolFlip}> <FontAwesome name='star-half-o' className='layer_handle_icon' /> </div>
                        <div className="layer_handle layer_remove_handle" onClick={this.handleSymbolRemove}> <FontAwesome name='trash' className='layer_handle_icon'/> </div>
                    </Rnd>
                    : null
                }

                {
                    // Render if symbolCanRoate and props.designerRenderMode is 'designer'
                    this.state.symbolCanRoate === 1 && this.props.designerRenderMode == 'designer' ?
                        <Rnd
                            style={{ background: 'transparent', zIndex: layerMoveStyle.zIndex + 10 }}
                            default={{
                                x: layerMoveStyle.top + layerMoveStyle.width,
                                y: layerMoveStyle.top - 24,
                                width: 24,
                                height: 24
                            }}
                            className={"layer_rotate_handle_wrapper" + (this.props.isActiveLayer ? ' active' : '')}
                            ref={c => { this.rotateRnd = c; }}
                            onDragStart={this.handleSymbolRotateStart}
                            onDrag={this.handleSymbolRotate}
                            onDragStop={this.handleSymbolRotateEnd}
                            enableResizing={{ top:false, right:false, bottom:false, left:false, topRight:false, bottomRight:false, bottomLeft:false, topLeft:false }}
                        >
                            <div className="layer_handle layer_rotate_handle" > <FontAwesome name='undo' className='layer_handle_icon' /> </div>
                        </Rnd>
                        : null
                }

            </div>
        );
    }
  }

export default ResizeSymbolPreviewLayer;




// WEBPACK FOOTER //
// ./src/ResizeSymbolPreviewLayer.js